import { render, staticRenderFns } from "./MilestonesSettingsModal.vue?vue&type=template&id=60d4f8a2&"
import script from "./MilestonesSettingsModal.vue?vue&type=script&lang=js&"
export * from "./MilestonesSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports